import { createMachine } from 'xstate';

export const accroupieMachine = createMachine({
  id: 'accroupie',
  initial: 'ac-Holding Down',
  states: {
    "ac-Crouch To Stand": { on: { "NEXT01": "ac-Crouch To Stand9001" }},
    "ac-Crouch To Stand9001": { on: { "NEXT01": "ac-Crouching" }},
    "ac-Crouching": { on: { "NEXT01": "ac-Football Hike" }},
    "ac-Football Hike": { on: { "NEXT01": "ac-Grenade Throw" }},
    "ac-Grenade Throw": { on: { "NEXT01": "ac-Gunplay" }},
    "ac-Gunplay": { on: { "NEXT01": "ac-Holding Down" }},
    "ac-Holding Down": { on: { "NEXT01": "ac-Kneeling" }},
    "ac-Kneeling": { on: { "NEXT01": "ac-Kneeling Idle" }},
    "ac-Kneeling Idle": { on: { "NEXT01": "ac-Military Signaling" }},
    "ac-Military Signaling": { on: { "NEXT01": "ac-Standing Up" }},
    "ac-Standing Up": { on: { "NEXT01": "ac-Crouch To Stand" }},
  }
});
